<div class="home-page">
    <form>
        <div class="container">
            <div class="text-center">
                <h2>{{ 'common.loading' | translate }}</h2>
            </div>            
        </div>
    </form>
</div>